import { $ } from "../third-party-imports";

export function updateSearchTermOnBanner()
{
    if (localStorage.getItem('searchTerm') !== undefined)
    {
        $('.bannerHeroContainer .propertForm').find('input').val(localStorage.getItem('searchTerm'));
    }
}
